// import ProductAddToCartHOC from '@common/components/ProductAddToCartHOC';
import Product from '@common/models/Product';
import { addProductToCart } from '@common/store/cart/slice';
import { subtractProductFromCart } from '@common/store/cart/slice';
import { addToast } from '@common/store/toasts/slice';
import Gallery from '@components/Gallery';
import ProductAddToCart from '@components/ProductAddToCart';
// import StarRating from '@components/Rating/StarRating';
// import Share from '@components/Share';
// import Close from '@images/Close.svg';
// import Rupee from '@instamojo/rupee';
// import Editor from '@lib/Editor';
import classnames from 'classnames';
import React from 'react';

interface EventProps {
  product: Product;
  addProductToCart: typeof addProductToCart;
  cartProductQuantity: number;
  addToast: typeof addToast;
  storeType: string;
  subtractProductFromCart: typeof subtractProductFromCart;
  quickView?: boolean;
  onClose?: () => void;
  review: number;
  scrollToReview?: () => void;
  wishListFeature: boolean;
  finalProduct: Product;
  hocArgs: unknown;
  productVideoFeature: boolean;
}

const Event: React.FC<EventProps> = ({
  product,
  addProductToCart,
  subtractProductFromCart,
  cartProductQuantity,
  addToast,
  storeType,
  review,
  // onClose,
  quickView,
  scrollToReview,
  finalProduct,
  hocArgs,
  wishListFeature,
  productVideoFeature,
}) => {
  return (
    <div className="w-full">
      <div className={classnames(`bg-white rounded-md `)}>
        <div className="flex flex-wrap md:flex-no-wrap">
          <div className={classnames('w-full md:w-fit')}>
            <Gallery
              isZoomEnabled={false}
              images={finalProduct.images.length ? finalProduct.images : product.images}
              quickView={quickView}
              inStock={finalProduct.inStock}
              imageDescription={`${finalProduct.images.length ? finalProduct.title : product.title}${
                finalProduct?.optionValues?.length ? '_' + finalProduct?.optionValues.join('_') : ''
              }`}
              productVideoUrl={finalProduct.productVideoUrl}
              productVideoEnabled={productVideoFeature ? finalProduct.productVideoEnabled : false}
            />
          </div>
          <div className={classnames(`flex flex-col md:ml-30 mt-24 md:mt-0 w-full`)} color-customisation="page-bg">
            <div
              className={classnames(
                'flex text-16 md:text-24 leading-28 md:leading-38 font-bold text-black content-start',
                {
                  'md:w-400 w-full': quickView,
                  'w-full': !quickView,
                },
              )}
              font-customisation="section-heading"
              color-customisation="page-heading"
            >
              {finalProduct.title}
            </div>
            <ProductAddToCart
              product={product}
              hocArgs={hocArgs}
              addToast={addToast}
              cartProductQuantity={cartProductQuantity}
              addProductToCart={addProductToCart}
              subtractProductFromCart={subtractProductFromCart}
              storeType={storeType}
              isEvent={true}
              quickView={quickView}
              review={review}
              scrollToReview={scrollToReview}
              wishListFeature={wishListFeature}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Event;
